import { FIREBASE_AUTH_ANONSIGNIN, JAVA_SVC } from "../config";
import { apiFetch } from "./httpClient";

export async function addUser(userData) {
  const response = await apiFetch("/users", {
    method: "POST",
    body: JSON.stringify(userData),
  });

  const data = await response.json();
  const resData = await data;

  if (!response.ok) {
    let errorMessage;
    if (data && data.error && data.error.message) {
      errorMessage = data.error.message;
    }
    throw new Error(errorMessage);
  }
  return resData;
}

export async function signInUser(userData) {
  const response = await apiFetch("/auth/login", {
    method: "POST",
    body: JSON.stringify({
      identifier: userData.email,
      password: userData.pass,
    }),
  });

  const data = await response.json();
  const resData = await data;

  if (!response.ok) {
    let errorMessage;
    if (data && data.status === 0 && data.message) {
      errorMessage = data.message;
    }
    throw new Error(errorMessage);
  }

  return resData.data;
}

export async function anonSignInUser(userData) {
  const response = await fetch(`${FIREBASE_AUTH_ANONSIGNIN}`, {
    method: "POST",
    body: JSON.stringify(userData),
    headers: {
      "Content-Type": "application/json",
    },
  });

  const data = await response.json();
  const resData = await data;

  if (!response.ok) {
    let errorMessage;
    if (data && data.error && data.error.message) {
      errorMessage = data.error.message;
    }
    throw new Error(errorMessage);
  }

  return resData;
}

export async function getUserById(id) {
  const response = await apiFetch(`/users/${id}`, {
    method: "GET",
  });

  const data = await response.json();
  const resData = await data;

  if (!response.ok) {
    let errorMessage;
    if (data && data.error && data.error.message) {
      errorMessage = data.error.message;
    }
    throw new Error(errorMessage);
  }

  return resData;
}

export async function updateUser(userData) {
  const response = await apiFetch(`/users/${userData.userId}`, {
    method: "PUT",
    body: JSON.stringify(userData),
  });

  const data = await response.json();
  const resData = await data;

  if (!response.ok) {
    let errorMessage;
    if (data && data.error && data.error.message) {
      errorMessage = data.error.message;
    }
    throw new Error(errorMessage);
  }
  return resData;
}
